import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p3" }
const _hoisted_2 = { class: "mb4" }
const _hoisted_3 = { class: "input-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { for: "noOfGames" }, "No of games", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_RegisterFormOnly = _resolveComponent("RegisterFormOnly")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Input, {
          type: "number",
          style: {"width":"300px"},
          modelValue: _ctx.noOfGames,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.noOfGames = $event)),
          id: "noOfGames"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_RegisterFormOnly, {
      onSubmit: _ctx.submit,
      "loading-text": _ctx.loading || _ctx.$t('checkout.withRegister.payAndRegister')
    }, null, 8, ["onSubmit", "loading-text"])
  ]))
}